export default __webpack_public_path__ + "static/media/mfa.9e8b37c5.svg";